import React from "react";
import { Navbar } from "../commn/Navbar";
import image1 from "../image/hero.jpg";
import "../style/css/client/home.css";
import { About } from "./home/About";
import { Contact } from "./home/Contact";
import { Object } from "./home/Object";
import { Product } from "./home/Product";
import { HomeNews } from "./home/HomeNews";
// import { Search } from '../search/Search';
// import initialDetails from '../search/initialDetails';
import { AskEmbryo } from "./AskEmbryo";

export const Home = () => {
  const sl = {
    transition: "ease 1ms",
  };

  return (
    <>
    <div className="bgwhite page-content" style={{ position: "relative", minHeight: "100vh" }}>
      <div>
        <section>
          <Navbar className="" />
        </section>
      </div>
      <div>
        <section>
          <div className="hero-section position-relative" style={sl}>
        <img
          className="d-block w-100 h-100 blog-image-mask"
          style={{ objectFit: "cover" }}
          src={image1}
          alt="Welcome to SLTMobitel R&D"
        />
        <div className="hero-overlay-text position-absolute d-flex flex-column justify-content-center align-items-center w-100 h-100" style={{ top: "0", left: "0", pointerEvents: "none" }}>
          <h1 className="fw-bolder text-white text-center" style={{ textShadow: "0 4px 15px rgba(0,0,0,1)", fontWeight: "800" }}>Welcome to <br/> SLTMobitel R&D</h1>
          <p className="mt-4 fs-5 text-white text-center" style={{ textShadow: "0 2px 8px rgba(0,0,0,1)", letterSpacing: "2px", opacity: 0.9 }}>Make Your Own Path to Discover The World</p>
        </div>
      </div>
        </section>

        <Object />
        <About />
        <Product />
        <HomeNews />        <br />
        {/* <Search details={initialDetails}/> */}
        <Contact />
      </div>
    </div>

      {/* Ask Embryo AI Chatbot */}
      <AskEmbryo />
    </>
  );
};

